import { render, staticRenderFns } from "./enhancedTagMasterData.vue?vue&type=template&id=52dfd49c&lang=html"
import script from "./enhancedTagMasterData.vue?vue&type=script&lang=js"
export * from "./enhancedTagMasterData.vue?vue&type=script&lang=js"
import style0 from "./enhancedTagMasterData.vue?vue&type=style&index=0&id=52dfd49c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports